__webpack_require__.p = "/setu_beta_frontend/";